import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  objectFit: 'cover',
  borderRadius: 50,
};
